import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { modal } from '@/share/components';

import { ref, reactive } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'search-add-user-view',
  setup(__props, {
    expose: __expose
  }) {
    const userList = ref([]);
    const addCount = ref(0);
    const searchFields = reactive([{
      field: 'search',
      title: '查找用户',
      span: 24,
      itemRender: {
        name: 'VxeInput',
        props: {
          placeholder: '手机号、账号或昵称'
        }
      }
    }]);
    const {
      loading,
      runAsync: prepareAddSearchUsersApi
    } = fetchApi('org.prepareAddSearchUsers');
    const searchUsers = async search => {
      const {
        error,
        rows
      } = await prepareAddSearchUsersApi({
        search
      });
      if (error) return;
      userList.value = rows;
    };
    const columns = reactive([{
      type: 'seq',
      title: '序号',
      width: 70,
      fixed: 'left'
    }, {
      field: 'username',
      title: '账号',
      width: 120
    }, {
      field: 'nickname',
      title: '昵称',
      width: 220
    }, {
      field: 'action',
      title: '操作',
      slots: {
        default: 'action'
      },
      width: 90
    }]);
    const gridOptions = reactive({
      border: true,
      headerAlign: 'center',
      align: 'left',
      rowConfig: {
        keyField: 'id',
        isCurrent: true,
        isHover: true
      },
      columnConfig: {
        resizable: true
      }
    });
    const {
      runAsync: myOrgAddUserApi
    } = fetchApi('org.myOrgAddUser', {
      showError: false
    });
    const doAddUserToOrg = async user => {
      const {
        id,
        nickname
      } = user || {};
      if (!id) return Promise.resolve(false);
      const {
        error
      } = await myOrgAddUserApi({
        userId: user.id,
        admin: false
      });
      if (error) {
        modal.notification.error(error);
        return;
      }
      modal.notification.success(`添加${nickname}用户成功`);
      addCount.value += 1;
      return Promise.resolve(true);
    };
    const handleAddUser = async user => {
      console.log('user:', user);
      const res = await doAddUserToOrg(user);
      if (!res) return;
      const rows = [...userList.value];
      const idx = rows.findIndex(t => t.id === user.id);
      if (idx === -1) return;
      rows.splice(idx, 1);
      userList.value = rows;
    };
    const handleDoSearchEvent = params => {
      const {
        search
      } = params;
      if (!search) return;
      searchUsers(search);
    };
    __expose({
      confirmListener() {
        return Promise.resolve(addCount.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      const _component_mg_list_page_layout = _resolveComponent("mg-list-page-layout");
      return _openBlock(), _createBlock(_component_mg_list_page_layout, {
        "search-fields": _unref(searchFields),
        onSearch: handleDoSearchEvent
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps({
          columns: _unref(columns),
          loading: _unref(loading),
          data: _unref(userList)
        }, _unref(gridOptions)), {
          action: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_button, {
            onClick: () => handleAddUser(row)
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("添加", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 16, ["columns", "loading", "data"])]),
        _: 1
      }, 8, ["search-fields"]);
    };
  }
};